import { InView } from 'react-intersection-observer'

import { useQuery } from '@apollo/client'
import React, { useEffect, useState, useRef } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Box, Flex } from 'rebass/styled-components'
import {
    IonPage,
    IonLoading,
    IonHeader,
    IonToolbar,
    IonSearchbar,
    IonButtons,
    IonBackButton,
} from '@ionic/react'
import IonContent from '../../components/IonContent'

import {
    GET_COLLECTIONS,
    GET_COLLECTION_BY_HANDLE,
    GET_ALL_COLLECTIONS_PRODUCTS,
} from '../../graphql/queries'
import ProductListItem from '../../components/ProductListItem'
import Header from '../../components/Header'

export default () => {
    const query = useParams()
    const [activeHandle, setActiveHandle] = useState()
    const handle = query.handle

    const scrollRef = useRef(false)
    const contentRef = useRef()

    useEffect(() => {
        if (handle !== ':handle') {
            setTimeout(() => handleScroll(handle), 1000)
        }
    }, [handle])

    const handleScroll = (handle) => {
        setActiveHandle(handle)
        scrollRef.current = true
        document.querySelector(`#${handle}`)?.scrollIntoView({
            behavior: 'smooth',
        })

        // disable onViewChange action when use scrollIntoView
        setTimeout(() => (scrollRef.current = false), 1500)
    }

    const { data, loading } = useQuery(GET_ALL_COLLECTIONS_PRODUCTS)
    const collections = data?.collections?.edges?.map(({ node }) => node) || []

    const onViewChange = (inView, handle) => {
        if (inView && !scrollRef.current) {
            setActiveHandle(handle)
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <Flex alignItems="center">
                        <IonBackButton slot="start" text="" defaultHref="/" />

                        <Flex as={Link} to="/search" style={{ textAlign: 'left' }} flex="1">
                            <IonSearchbar slot="primary" placeholder="search..."></IonSearchbar>
                        </Flex>
                    </Flex>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen ref={contentRef}>
                <IonLoading isOpen={loading}></IonLoading>
                {/* <Flex
                    height="100%"
                    sx={{
                        overflow: 'hidden',
                    }}
                > */}
                <Flex
                    width="120px"
                    bg="#eee"
                    height="100%"
                    flexDirection="column"
                    sx={{
                        position: 'fixed',
                        left: 0,
                    }}
                >
                    {collections.map((x) => (
                        <Box
                            py="15px"
                            pl="5px"
                            onClick={() => handleScroll(x.handle)}
                            bg={x.handle === activeHandle ? 'primary' : 'transparent'}
                            color={x.handle === activeHandle ? 'white' : 'black'}
                            sx={{ borderBottom: '1px solid #eee' }}
                            key={x.handle}
                        >
                            {x.title}
                        </Box>
                    ))}
                </Flex>
                <Box flex="1" id="container" pl="125px">
                    {collections.map((x) => (
                        <InView
                            key={x.handle}
                            id={x.handle}
                            onChange={(inView) => onViewChange(inView, x.handle)}
                        >
                            {x.products.edges.map(({ node }) => (
                                <ProductListItem node={node} />
                            ))}
                        </InView>
                    ))}
                </Box>
                {/* </Flex> */}
            </IonContent>
        </IonPage>
    )
}
